import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Outcome from './Outcome'
import Spinner from '@components/spinner'

class OutcomePage extends Component {
  static propTypes = {
    projectStore: PropTypes.object,
    deliverableStore: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.props.deliverableStore.get(this.props.projectStore.id)
  }

  render () {
    const { projectStore, deliverableStore } = this.props

    if (deliverableStore.loading) return <Spinner />

    return (
      <Outcome deliverableStore={deliverableStore} matchId={projectStore.id} />
    )
  }
}

export default inject('projectStore', 'deliverableStore')(observer(OutcomePage))
